/**
 * A secondary section of the run page, folded by default (progressive disclosure): a quiet row
 * with a chevron, the title and a count; the content opens under it.
 */
import { useId, useState } from 'react';
import type { ReactNode } from 'react';
import { GroupChevron, Pressable, cn } from '@orgus/ui';

export function RunSection({ title, count, defaultOpen = false, actions, children, className }: { title: string; count?: ReactNode; defaultOpen?: boolean; actions?: ReactNode; children: ReactNode; className?: string }) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <section className={cn('flex min-w-0 flex-col', className)} aria-label={title}>
      <div className="flex h-row min-w-0 items-center gap-2">
        <Pressable className="flex h-row min-w-0 flex-1 items-center gap-2 rounded-control text-left hover:text-fg" aria-expanded={open} aria-controls={id} onClick={() => setOpen((v) => !v)}>
          <GroupChevron open={open} />
          <span className="truncate text-ui font-medium text-fg-muted">{title}</span>
          {count != null && <span className="truncate text-caption text-fg-subtle num">{count}</span>}
        </Pressable>
        {open && actions && <span className="flex shrink-0 items-center gap-1">{actions}</span>}
      </div>
      {open && (
        <div id={id} className="pb-4 pl-6">
          {children}
        </div>
      )}
    </section>
  );
}
